/**
 * 输入框限制指令
 * 默认限制只能输入数字，可通过binding.value传入自定义规则
 * @example
 * // 默认限制数字
 * <input v-inputLimiter>
 * // 限制数字和字母
 * <input v-inputLimiter="/^[0-9a-zA-Z]*$/">
 * // 带配置项
 * <input v-inputLimiter="{ pattern: /^\d{1,10}$/, allowEmpty: true, message: '请输入1-10位数字' }">
 */
export default {
  inserted(el, binding) {
    // 处理配置
    let config = {
      pattern: /[^0-9]/g, // 默认允许数字(包括空值)
      allowEmpty: true, // 默认允许空值
      message: '', // 默认提示信息
      maxValue: undefined, // 默认最大值
      minValue: undefined, // 默认最小值
      trigger: ['input', 'paste', 'blur'] // 默认触发事件
    };

    // 如果binding.value是正则表达式，则使用它作为pattern
    if (binding.value instanceof RegExp) {
      config.pattern = binding.value;
    } 
    // 如果是对象，则合并配置
    else if (typeof binding.value === 'object') {
      config = { ...config, ...binding.value };
    }

    // 验证函数
    const validate = (value) => {
      // 如果允许空值且值为空，则通过验证
      if (config.allowEmpty && value === '') return true;
      // 否则使用pattern验证
      return config.pattern.test(value);
    };

    // 处理输入的函数
    const handleInput = (e) => {
      const target = e.target;
      const value = target.value;
      // console.log(e,el,'===>>');
      
      // 验证失败，将值替换
      const newValue = value.replace(config.pattern, '');
      if (newValue !== value) {
        // if(config.maxValue && Number(value) > config.maxValue){
        //   target.value = config.maxValue;
        //   return;
        // }
        // if(config.minValue && Number(value) < config.minValue){
        //   target.value = config.minValue;
        //   return;
        // }
        target.value = newValue;
        // 显示错误信息（拓展待开发）
        if (config.message && typeof config.message === 'string') {
          console.warn(config.message);
        }
      }
      // 移除手动触发输入事件的逻辑，避免无限循环
    };

    // 绑定事件
    config.trigger.forEach(eventType => {
      el.addEventListener(eventType, handleInput);
    });

    // 将 handleInput 挂载到元素上，方便在 unbind 中使用
    el._inputLimiterHandleInput = handleInput;
  },

  // 指令解绑时清理事件监听
  unbind(el) {
    const config = {
      trigger: ['input', 'paste', 'blur']
    };
    if (el._inputLimiterHandleInput) {
      config.trigger.forEach(eventType => {
        el.removeEventListener(eventType, el._inputLimiterHandleInput);
      });
      // 清理挂载的方法
      delete el._inputLimiterHandleInput;
    }
  }
};
